import { Loading } from "notiflix";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetOrderDeatils,
  UpateOrderStstus,
} from "../../../../redux/actions/Admin/AdminOrders";

const thClass =
  "text-left px-5 py-3 text-[10px] text-[#E52324] uppercase tracking-widest";

function orderStatusClass(status = "") {
  const normalized = status.toLowerCase();
  if (normalized.includes("pending")) return "bg-amber-500/15 text-amber-400";
  if (normalized.includes("refund")) return "bg-red-500/15 text-red-400";
  if (normalized.includes("deliver")) return "bg-emerald-500/15 text-emerald-400";
  return "bg-white/10 text-white/50";
}

const NewOrders = ({ setActive }) => {
  const orderData = useSelector((state) => state.AdminOrders.OrderData)
    ?.slice(-5)
    ?.reverse();
  const adminloading = useSelector((state) => state.user.adminloading);
  const [orderStatus, setOrderStatus] = useState("");
  const [orderId, setOrderId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (adminloading === true) {
      Loading.standard("Loading Please Wait", {
        svgColor: "#CD292E",
      });
    } else {
      Loading.remove();
    }
  }, [adminloading]);

  return (
    <>
      <div className="bg-[#0F172A] border border-[#1a2744] rounded-xl">
        <div className="px-5 py-4 border-b border-[#1a2744]">
          <h3 className="text-white text-[16px]" style={{ fontWeight: 700 }}>
            New Order
          </h3>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-[#1a2744]">
                <th className={thClass} style={{ fontWeight: 700 }}>
                  OrderID
                </th>
                <th className={thClass} style={{ fontWeight: 700 }}>
                  Ticket Type
                </th>
                <th className={thClass} style={{ fontWeight: 700 }}>
                  Status
                </th>
                <th className={thClass} style={{ fontWeight: 700 }}>
                  Total Tickets
                </th>
                <th className={thClass} style={{ fontWeight: 700 }}>
                  Total Amount
                </th>
                <th className={thClass} style={{ fontWeight: 700 }}>
                  Payment Method
                </th>
                <th className={thClass} style={{ fontWeight: 700 }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {orderData?.map((item, index) => (
                <tr
                  key={item?._id || index}
                  className="border-b border-[#1a2744]/50 hover:bg-[#1a2744]/30 transition-colors"
                >
                  <td className="px-5 py-3 text-[12px] text-blue-400" style={{ fontWeight: 600 }}>
                    #{item?._id?.slice(0, 5)}
                  </td>
                  <td className="px-5 py-3 text-[11px] text-white/40">
                    {item?.type}name
                  </td>
                  <td className="px-5 py-3">
                    <span
                      className={`px-2 py-0.5 rounded-full text-[9px] uppercase tracking-wider ${orderStatusClass(
                        item?.status
                      )}`}
                      style={{ fontWeight: 600 }}
                    >
                      {item?.status}
                    </span>
                  </td>
                  <td className="px-5 py-3 text-[11px] text-white/40 text-center">
                    {item?.items?.length}
                  </td>
                  <td className="px-5 py-3 text-[12px] text-white" style={{ fontWeight: 600 }}>
                    ${Number(item?.totalAmount || 0).toFixed(2)}
                  </td>
                  <td className="px-5 py-3 text-[11px] text-white/40">{item?.payments}</td>
                  <td className="px-5 py-3">
                    <div className="flex items-center gap-2 flex-wrap">
                      <button
                        type="button"
                        className="text-[10px] text-blue-400 hover:underline bg-transparent border-0 p-0 cursor-pointer"
                        style={{ fontWeight: 500 }}
                        onClick={() => {
                          setActive(10);
                          dispatch(GetOrderDeatils(item?._id));
                        }}
                      >
                        Details
                      </button>
                      <button
                        type="button"
                        className="text-[10px] text-white px-2.5 py-1 rounded bg-emerald-600 hover:bg-emerald-700 transition-colors border-0 cursor-pointer"
                        style={{ fontWeight: 600 }}
                        onClick={() => {
                          setShowModal(true);
                          setOrderId(item?._id);
                          setOrderStatus("");
                        }}
                      >
                        Update Status
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && (
        <div className="fixed z-50 inset-0 flex items-center justify-center p-4">
          <button
            type="button"
            className="absolute inset-0 bg-black/70"
            onClick={() => setShowModal(false)}
            aria-label="Close modal"
          />
          <div className="relative w-full max-w-md bg-[#0F172A] border border-[#1a2744] rounded-xl shadow-xl overflow-hidden">
            <div className="px-5 py-4 border-b border-[#1a2744] flex items-center justify-between">
              <h3 className="text-white text-[16px]" style={{ fontWeight: 700 }}>
                Update Status
              </h3>
              <button
                type="button"
                onClick={() => setShowModal(false)}
                className="text-white/40 hover:text-white text-xl leading-none bg-transparent border-0 cursor-pointer"
              >
                ×
              </button>
            </div>
            <div className="px-5 py-4">
              <select
                className="w-full text-[13px] text-white bg-[#1a2744] border border-[#243354] rounded-lg py-2.5 px-3 outline-none"
                onChange={(e) => setOrderStatus(e.target.value)}
                value={orderStatus}
              >
                <option value="">Select order status</option>
                <option value="Pending">Pending</option>
                <option value="Refund">Refund</option>
                <option value="Refund Reject">Refund Reject</option>
                <option value="Deliverd">Deliverd</option>
              </select>
            </div>
            <div className="px-5 py-4 border-t border-[#1a2744] flex justify-end gap-2">
              <button
                type="button"
                className="text-[12px] text-white/50 hover:text-white px-4 py-2 rounded-lg border border-[#243354] bg-transparent cursor-pointer"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="text-[12px] text-white px-4 py-2 rounded-lg bg-[#E52324] hover:bg-[#c41e1f] border-0 cursor-pointer"
                style={{ fontWeight: 600 }}
                onClick={async () => {
                  await dispatch(UpateOrderStstus(orderId, orderStatus));
                  setShowModal(false);
                  setOrderId(null);
                  setOrderStatus("");
                }}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NewOrders;
